import { useEffect } from 'react';
import { useWatch } from 'react-hook-form';
import { Checkbox, FormGroup, FormControlLabel } from '@mui/material';
import { Controller } from 'react-hook-form';
import { ICheckBoxFormUI } from '../../../common/models';
import { FormDataUCC3 } from '../schema';

import { Accordion } from '../constants';

const ContinuationCheckbox = ({
  control,
  formState: { errors },
  handleCheckboxAccordionState,
}: ICheckBoxFormUI<FormDataUCC3>) => {
  const eventContinuation = useWatch({
    control,
    name: 'eventContinuation',
  });

  useEffect(() => {
    if (eventContinuation) {
      handleCheckboxAccordionState(Accordion.Continuation);
    }
  }, [eventContinuation]);

  return (
    <Controller
      control={control}
      name="eventContinuation"
      render={({ field }) => (
        <FormGroup {...field}>
          <FormControlLabel control={<Checkbox checked={eventContinuation} />} label="" />
        </FormGroup>
      )}
    />
  );
};

export default ContinuationCheckbox;
